var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bussiness-wrapper-step6"},[_c('div',{staticClass:"container flexColumn"},[_c('LandingBussinessBtns')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }